import './App.css';
import { BrowserRouter as Router } from 'react-router-dom';
import ApplicationRoutes from './Routes';

function App() {
  return (
    <div>
      <Router>
        <ApplicationRoutes />
      </Router>
    </div>
  );
}

export default App;
